// Menu
document.querySelectorAll('.burgerMenu').forEach(function (burger) {
    burger.addEventListener('click', function () {
        document.querySelector('#menu', '.overlay').classList.add('active');
        document.querySelector('.overlay').classList.add('active');
    });
});

document.querySelector('.close').addEventListener('click', function () {
    document.querySelector('#menu').classList.remove('active');
    document.querySelector('.overlay').classList.remove('active');
});


document.querySelector('.overlay').addEventListener('click', function () {
    document.querySelector('#menu').classList.remove('active');
    document.querySelector('.overlay').classList.remove('active');
});


// Sticky header

document.addEventListener("DOMContentLoaded", () => {
    const stickyMenu = document.querySelector('#stickyMenu');
    // On prend la section-breadcrumb qui n'est PAS dans stickyMenu
    const breadcrumb = document.querySelector(".section-breadcrumb:not(#stickyMenu .section-breadcrumb)");

    if (!stickyMenu || !breadcrumb) return;

    const breadcrumbOffset = breadcrumb.offsetTop + breadcrumb.offsetHeight;

    window.addEventListener("scroll", () => {
        if (window.scrollY > breadcrumbOffset) {
            stickyMenu.classList.add("active");
        } else {
            stickyMenu.classList.remove("active");
        }
    });
});




// Produits : Filtres
const filtersBtn = document.querySelector('.section-products-filters');
if (filtersBtn) {
    filtersBtn.addEventListener('click', function () {
        document.querySelector('.section-filters').classList.add('active');
        document.querySelector('.overlay').classList.add('active');
    });

    const closeBtn = document.querySelector('.section-filters .close');
    if (closeBtn) {
        closeBtn.addEventListener('click', function () {
            document.querySelector('.section-filters').classList.remove('active');
            document.querySelector('.overlay').classList.remove('active');
        });
    }
}

// init Swiper:
// init Swiper plein écran
const swiper = new Swiper('.swiperFullScreen', {
    loop: true,
    speed: 3000,
    effect: "fade",
    autoplay: {
        delay: 3000,
        disableOnInteraction: false,
    },
});

// init Swiper multiple
// init Swiper multiple
document.querySelectorAll('.swiperMultiple').forEach((el) => {
    const nbSlides = el.querySelectorAll('.swiper-slide').length;

    const map  = {1: 1, 2: 2, 3: 3, 4: 3, 5: 4};
    const mapM = {1: 1, 2: 2, 3: 3, 4: 3, 5: 4};

    const desktop = map[nbSlides] ?? 4;  // 6 et plus → 4
    const mobile  = mapM[nbSlides] ?? 4; // 6 et plus → 4

    const wrapper = el.parentElement;

    new Swiper(el, {
        slidesPerView: 1,
        spaceBetween: 30,
        loop: nbSlides >= desktop * 2,
        initialSlide: nbSlides > 1 ? 1 : 0,
        speed: 1000,
        autoplay: {
            delay: 2000,
            disableOnInteraction: false,
        },
        navigation: {
            nextEl: wrapper.querySelector('.swiper-button-next'),
            prevEl: wrapper.querySelector('.swiper-button-prev'),
        },
        breakpoints: {
            768: {
                slidesPerView: mobile,
                initialSlide: nbSlides > 2 ? 2 : 0,
            },
            1024: {
                slidesPerView: desktop,
            },
        }
    });
});

const swiperT = new Swiper('.swiperTeam', {
    slidesPerView: 1,
    spaceBetween: 24,
    loop: true,
    initialSlide: 1, // ← démarre à une slide plus éloignée
    speed: 1000,
    speed: 1000,
    autoplay: {
        delay: 2000,
        disableOnInteraction: false,
    },
    navigation: {
        nextEl: ".section-team-diapo .swiper-button-next",
        prevEl: ".section-team-diapo .swiper-button-prev",
    },
    breakpoints: {
        600: {   // tablettes
            slidesPerView: 3,
            initialSlide: 1
        },


        1280: {   // tablettes
            slidesPerView: 4,
        },
    }
});


const swiperP = new Swiper('.swiperProject', {
    slidesPerView: 1,
    spaceBetween: 24,
    initialSlide: 1, // ← démarre à une slide plus éloignée
    speed: 1000,
    loop: true,
    autoplay: {
        delay: 2000,
        disableOnInteraction: false,
    },
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },


    breakpoints: {
        600: {
            slidesPerView: 2,
            initialSlide: 1
        },

        1100: {
            slidesPerView: 3,
            loop: false,
        },

    }
});

const swiperD = new Swiper('.swiperDevice', {
    slidesPerView: 2,
    spaceBetween: 24,
    initialSlide: 1, // ← démarre à une slide plus éloignée
    speed: 1000,
    loop: true,
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },


    breakpoints: {
        600: {
            slidesPerView: 3,
            initialSlide: 1
        },

        1100: {
            slidesPerView: 5,
            loop: false,
        },

    }
});

// POPIN (WHATSAPP...)

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-target]').forEach(btn => {
        btn.addEventListener('click', e => {
            e.preventDefault();
            const selector = btn.getAttribute('data-target');
            const popin = document.querySelector(selector);
            if(popin) popin.classList.add('active');
        });
    });

    document.querySelectorAll('.popin .close').forEach(closeBtn => {
        closeBtn.addEventListener('click', () => {
            const popin = closeBtn.closest('.popin');
            if(popin) popin.classList.remove('active');
        });
    });
});


// WHATSAPP SCROLL

document.addEventListener('DOMContentLoaded', () => {
    const whatsappLink = document.querySelector('.link-whatsapp');
    const scrollThreshold = 100; // nombre de pixels avant d'ajouter la classe

    window.addEventListener('scroll', () => {
        if (window.scrollY > scrollThreshold) {
            whatsappLink.classList.add('active');
        } else {
            whatsappLink.classList.remove('active');
        }
    });
});


// Form 7
document.querySelectorAll('.custom-file-upload input[type="file"]').forEach(input => {
    input.addEventListener('change', function () {
        const fileName = this.files.length > 0 ? this.files[0].name : "Aucun fichier sélectionné";
        this.closest('.custom-file-upload').querySelector('.file-name').textContent = fileName;
    });
});

// Animation photos

document.addEventListener("DOMContentLoaded", function () {
    const fadeEls = document.querySelectorAll(
        ".fade-in-left, .fade-in-right, .fade-in-top, .fade-in-bottom"
    );

    const appearOnScroll = new IntersectionObserver(
        (entries, observer) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.classList.add("fade-in-visible");
                    observer.unobserve(entry.target); // Animation une seule fois
                }
            });
        },
        {
            threshold: 0.1
        }
    );

    fadeEls.forEach(el => {
        appearOnScroll.observe(el);
    });
});


// Scroll smooth

document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
        anchor.addEventListener("click", function(e) {
            e.preventDefault();

            const target = document.querySelector(this.getAttribute("href"));
            if (!target) return;

            let headerOffset = 0;

            // StickyMenu seulement sur desktop (>= 768px)
            const sticky = document.querySelector("#stickyMenu");
            if (window.innerWidth >= 768 && sticky && sticky.classList.contains("active")) {
                headerOffset += sticky.offsetHeight;
            }

            // Toujours prendre en compte .n3-anchor-menu si présent
            const n3Anchor = document.querySelector(".n3-anchor-menu");
            if (n3Anchor) {
                headerOffset += n3Anchor.offsetHeight + 100;
            }

            const elementPosition = target.getBoundingClientRect().top + window.pageYOffset;
            const offsetPosition = elementPosition - headerOffset;

            window.scrollTo({
                top: offsetPosition,
                behavior: "smooth"
            });
        });
    });
});

// Lang EN cookie
document.addEventListener('DOMContentLoaded', function () {
    const langSwitch = document.querySelector('.switch-lang');
    const langSwitchFr = document.querySelector('.switch-lang-fr');
    if (langSwitch) {
        langSwitch.addEventListener('click', function(e) {
            e.preventDefault();
            document.cookie = "lang=en; path=/";
            window.location.href = window.location.pathname + '?menu=active';
        });

    }
    if (langSwitchFr) {
        langSwitchFr.addEventListener('click', function(e) {
            e.preventDefault();
            document.cookie = "lang=fr; path=/";
            window.location.href = window.location.pathname + '?menu=active';
        });
    }


    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('menu') === 'active') {
        document.querySelector('#menu').classList.add('active');
        document.querySelector('.overlay').classList.add('active');
    }

});


// Transition
